function NRGoogleIcon({ height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M22 12.2228C22 11.4001 21.9318 10.8001 21.7855 10.1774H12.2036V13.8892H17.8273C17.7145 14.811 17.1027 16.2001 15.7418 17.1338L15.7227 17.2574L18.7518 19.5574L18.9609 19.5774C20.89 17.8338 22 15.2665 22 12.2228Z"
        fill="#4285F4"
      />
      <path
        d="M12.2045 22.0002C14.9591 22.0002 17.2718 21.1111 18.9618 19.5774L15.7418 17.1338C14.88 17.7229 13.7236 18.1338 12.2045 18.1338C10.924 18.1339 9.67562 17.7332 8.63445 16.9877C7.59328 16.2423 6.81159 15.1896 6.39906 13.9774L6.27906 13.9874L3.12904 16.3765L3.08813 16.4892C4.76632 19.7556 8.21361 22.0002 12.2045 22.0002Z"
        fill="#34A853"
      />
      <path
        d="M6.40002 13.9773C6.17642 13.3419 6.06058 12.6736 6.05729 12C6.05729 11.3109 6.18275 10.6445 6.38547 10.0227L6.38002 9.88908L3.19091 7.46179L3.08637 7.51088C2.37345 8.89996 2.00108 10.4387 2 12C2 13.6109 2.39637 15.1336 3.08819 16.4891L6.40002 13.9773Z"
        fill="#FBBC05"
      />
      <path
        d="M12.2045 5.86638C14.1209 5.86638 15.4127 6.67729 16.15 7.35548L19.0291 4.60001C17.2609 2.9891 14.9591 2 12.2045 2C8.2127 2 4.76632 4.24456 3.08813 7.51094L6.38815 10.0228C6.80423 8.81063 7.58832 7.75862 8.63101 7.01351C9.6737 6.26841 10.923 5.86738 12.2045 5.86638Z"
        fill="#EB4335"
      />
    </svg>
  );
}

export default NRGoogleIcon;
